import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {ExternalApplicationOPEEnum} from "./ExternalApplicationOPEEnum";

class O {
}

/**
 * O Inner Class
 */
class I {
  id!: number;
}


/**
 * ChangeExternalApplicationSecretCB class
 */
export class ChangeExternalApplicationSecretCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(ExternalApplicationOPEEnum.ChangeExternalApplicationSecret);
    this.i = new I();
    this.o = new O();
  }

}
